export default __webpack_public_path__ + "static/media/Polygon.574b4aec.svg";